import { Outlet, useNavigate } from 'react-router-dom';

import { ContactList } from 'src/Components/Contacts/ContactList';
import { useFormatListedContacts } from 'src/Hooks/Format/useFormatListedContacts';
import useFetchExport from 'src/Hooks/Queries/useFetchExport';
import { ContactPreviewDto } from 'src/Services/API/generated';

import { Props } from './ExportContactPage.types';

const ExportContactPage = ({ token }: Props) => {
  const navigate = useNavigate();
  const { data, isLoading } = useFetchExport(token);
  const formattedContacts = useFormatListedContacts(
    data?.entities as unknown as ContactPreviewDto[]
  );

  return (
    <>
      <ContactList
        onContactClick={contact => navigate(`contact/${contact.id}`)}
        fetching={isLoading}
        contacts={formattedContacts}
      />
      <Outlet />
    </>
  );
};

export default ExportContactPage;
